"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-two/sections/bannerSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, ReactNode } from "react";

export type HomeTwoBannerSectionGeneratedProps = {
    sectionDiv0Div0ClassName?: string;
    /** Default: "1s" */
    sectionDiv0Div0Div0Div0DivDataWowDuration?: string;
    /** Default: "Comprehensive diagnosis by top specialists." */
    sectionDiv0Div0Div0Div0Div0P0PText?: ReactNode;
    /** Default: "Advanced Technology" */
    sectionDiv0Div0Div0Div0Div0Span0SpanText?: ReactNode;
    /** Default: "Consult" */
    sectionDiv0Div0Div0Div0H10H1Text?: ReactNode;
    /** Default: "Your Nearby Location." */
    sectionDiv0Div0Div0Div0H10H1Text2?: ReactNode;
    sectionDiv0Div0Div0Div0H10H1Visible?: boolean;
    sectionDiv0Div0Div0Div0H10H1Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0H10H1Props?: Partial<ComponentProps<"h1">>;
    /** Default: "Best Doctors" */
    sectionDiv0Div0Div0Div0H10Span0SpanText?: ReactNode;
    /** Default: "all_routes.booking" */
    sectionDiv0Div0Div0Div0Link0LinkHref?: string;
    /** Default: "Book an Appointment" */
    sectionDiv0Div0Div0Div0Link0LinkText?: ReactNode;
    sectionDiv0Div0Div0Div0Link0LinkVisible?: boolean;
    sectionDiv0Div0Div0Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Embark on your healing journey with Doccure, where finding trusted doctors, booking appointments, and managing your health" */
    sectionDiv0Div0Div0Div0P0PText?: ReactNode;
    /** Default: "2s" */
    sectionDiv0Div0Div1Div0DivDataWowDuration?: string;
    /** Default: "Calling......." */
    sectionDiv0Div0Div1Div0Div0P0PText?: ReactNode;
    /** Default: "patient" */
    sectionDiv0Div0Div1Div0Div0Span0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/patients/patient22.jpg" */
    sectionDiv0Div0Div1Div0Div0Span0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div1Div0Div0Span0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div1Div0Div0Span0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0Div0Span0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "#" */
    sectionDiv0Div0Div1Div0Div1Link0LinkHref?: string;
    sectionDiv0Div0Div1Div0Div1Link0LinkVisible?: boolean;
    sectionDiv0Div0Div1Div0Div1Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0Div1Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "#" */
    sectionDiv0Div0Div1Div0Div1Link1LinkHref?: string;
    sectionDiv0Div0Div1Div0Div1Link1LinkVisible?: boolean;
    sectionDiv0Div0Div1Div0Div1Link1LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0Div1Link1LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "#" */
    sectionDiv0Div0Div1Div0Div1Link2LinkHref?: string;
    sectionDiv0Div0Div1Div0Div1Link2LinkVisible?: boolean;
    sectionDiv0Div0Div1Div0Div1Link2LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0Div1Link2LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "banner" */
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/banner/banner-02.png" */
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "bg" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/banner-01.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "bg" */
    sectionImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/banner-02.png" */
    sectionImageWithBasePath1ImageSrc?: string;
    sectionImageWithBasePath1ImageVisible?: boolean;
    sectionImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "bg" */
    sectionImageWithBasePath2ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/banner-03.png" */
    sectionImageWithBasePath2ImageSrc?: string;
    sectionImageWithBasePath2ImageVisible?: boolean;
    sectionImageWithBasePath2ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath2ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "bg" */
    sectionImageWithBasePath3ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/banner-04.png" */
    sectionImageWithBasePath3ImageSrc?: string;
    sectionImageWithBasePath3ImageVisible?: boolean;
    sectionImageWithBasePath3ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath3ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "bg" */
    sectionImageWithBasePath4ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/banner-05.png" */
    sectionImageWithBasePath4ImageSrc?: string;
    sectionImageWithBasePath4ImageVisible?: boolean;
    sectionImageWithBasePath4ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath4ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "bg" */
    sectionImageWithBasePath5ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/banner-06.png" */
    sectionImageWithBasePath5ImageSrc?: string;
    sectionImageWithBasePath5ImageVisible?: boolean;
    sectionImageWithBasePath5ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath5ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "bg" */
    sectionImageWithBasePath6ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/banner-07.png" */
    sectionImageWithBasePath6ImageSrc?: string;
    sectionImageWithBasePath6ImageVisible?: boolean;
    sectionImageWithBasePath6ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath6ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
};

const HomeTwoBannerSectionGenerated: FC<HomeTwoBannerSectionGeneratedProps> = ({
    sectionDiv0Div0Div0Div0Div0P0PText = "Comprehensive diagnosis by top specialists.",
    sectionDiv0Div0Div0Div0Div0Span0SpanText = "Advanced Technology",
    sectionDiv0Div0Div0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0Div0Div0H10H1Text = "Consult",
    sectionDiv0Div0Div0Div0H10H1Text2 = "Your Nearby Location.",
    sectionDiv0Div0Div0Div0H10H1Visible,
    sectionDiv0Div0Div0Div0H10H1Renderer,
    sectionDiv0Div0Div0Div0H10H1Props,
    sectionDiv0Div0Div0Div0H10Span0SpanText = "Best Doctors",
    sectionDiv0Div0Div0Div0Link0LinkHref = "all_routes.booking",
    sectionDiv0Div0Div0Div0Link0LinkText = "Book an Appointment",
    sectionDiv0Div0Div0Div0Link0LinkVisible,
    sectionDiv0Div0Div0Div0Link0LinkRenderer,
    sectionDiv0Div0Div0Div0Link0LinkProps,
    sectionDiv0Div0Div0Div0P0PText = "Embark on your healing journey with Doccure, where finding trusted doctors, booking appointments, and managing your health",
    sectionDiv0Div0Div1Div0Div0P0PText = "Calling.......",
    sectionDiv0Div0Div1Div0Div0Span0ImageWithBasePath0ImageAlt = "patient",
    sectionDiv0Div0Div1Div0Div0Span0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/patients/patient22.jpg",
    sectionDiv0Div0Div1Div0Div0Span0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div1Div0Div0Span0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div1Div0Div0Span0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div1Div0Div1Link0LinkHref = "#",
    sectionDiv0Div0Div1Div0Div1Link0LinkVisible,
    sectionDiv0Div0Div1Div0Div1Link0LinkRenderer,
    sectionDiv0Div0Div1Div0Div1Link0LinkProps,
    sectionDiv0Div0Div1Div0Div1Link1LinkHref = "#",
    sectionDiv0Div0Div1Div0Div1Link1LinkVisible,
    sectionDiv0Div0Div1Div0Div1Link1LinkRenderer,
    sectionDiv0Div0Div1Div0Div1Link1LinkProps,
    sectionDiv0Div0Div1Div0Div1Link2LinkHref = "#",
    sectionDiv0Div0Div1Div0Div1Link2LinkVisible,
    sectionDiv0Div0Div1Div0Div1Link2LinkRenderer,
    sectionDiv0Div0Div1Div0Div1Link2LinkProps,
    sectionDiv0Div0Div1Div0DivDataWowDuration = "2s",
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageAlt = "banner",
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/banner/banner-02.png",
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageProps,
    sectionImageWithBasePath0ImageAlt = "bg",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/banner-01.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    sectionImageWithBasePath1ImageAlt = "bg",
    sectionImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/banner-02.png",
    sectionImageWithBasePath1ImageVisible,
    sectionImageWithBasePath1ImageRenderer,
    sectionImageWithBasePath1ImageProps,
    sectionImageWithBasePath2ImageAlt = "bg",
    sectionImageWithBasePath2ImageSrc = "/Templates/Doccure/img/bg/banner-03.png",
    sectionImageWithBasePath2ImageVisible,
    sectionImageWithBasePath2ImageRenderer,
    sectionImageWithBasePath2ImageProps,
    sectionImageWithBasePath3ImageAlt = "bg",
    sectionImageWithBasePath3ImageSrc = "/Templates/Doccure/img/bg/banner-04.png",
    sectionImageWithBasePath3ImageVisible,
    sectionImageWithBasePath3ImageRenderer,
    sectionImageWithBasePath3ImageProps,
    sectionImageWithBasePath4ImageAlt = "bg",
    sectionImageWithBasePath4ImageSrc = "/Templates/Doccure/img/bg/banner-05.png",
    sectionImageWithBasePath4ImageVisible,
    sectionImageWithBasePath4ImageRenderer,
    sectionImageWithBasePath4ImageProps,
    sectionImageWithBasePath5ImageAlt = "bg",
    sectionImageWithBasePath5ImageSrc = "/Templates/Doccure/img/bg/banner-06.png",
    sectionImageWithBasePath5ImageVisible,
    sectionImageWithBasePath5ImageRenderer,
    sectionImageWithBasePath5ImageProps,
    sectionImageWithBasePath6ImageAlt = "bg",
    sectionImageWithBasePath6ImageSrc = "/Templates/Doccure/img/bg/banner-07.png",
    sectionImageWithBasePath6ImageVisible,
    sectionImageWithBasePath6ImageRenderer,
    sectionImageWithBasePath6ImageProps,
    sectionDiv0Div0ClassName,
}) => {
    return (
        <section className="banner-section-two">
            <div className="container">
                <div className={sectionDiv0Div0ClassName ?? "row align-items-end"}>
                    <div className="col-xl-6">
                        <div className="banner-content wow fadeInUp" data-wow-duration={sectionDiv0Div0Div0Div0DivDataWowDuration}>
                            <div className="banner-badge">
                                <span>{sectionDiv0Div0Div0Div0Div0Span0SpanText}</span>
                                <p>{sectionDiv0Div0Div0Div0Div0P0PText}</p>
                            </div>
                            {renderNode(sectionDiv0Div0Div0Div0H10H1Visible, sectionDiv0Div0Div0Div0H10H1Renderer, (
                                <h1 {...(sectionDiv0Div0Div0Div0H10H1Props ?? {})}>
                                    {sectionDiv0Div0Div0Div0H10H1Text}
                                    <span>{sectionDiv0Div0Div0Div0H10Span0SpanText}</span>
                                    {sectionDiv0Div0Div0Div0H10H1Text2}
                                </h1>
                            ))}
                            <p>{sectionDiv0Div0Div0Div0P0PText}</p>
                            {renderNode(sectionDiv0Div0Div0Div0Link0LinkVisible, sectionDiv0Div0Div0Div0Link0LinkRenderer, (
                                <SmartLink href={sectionDiv0Div0Div0Div0Link0LinkHref} className="btn btn-md btn-white" {...(sectionDiv0Div0Div0Div0Link0LinkProps ?? {})}>
                                    <i className="isax isax-lock me-2" />
                                    {sectionDiv0Div0Div0Div0Link0LinkText}
                                </SmartLink>
                            ))}
                        </div>
                    </div>
                    <div className="col-xl-6">
                        <div className="banner-img wow fadeInUp" data-wow-duration={sectionDiv0Div0Div1Div0DivDataWowDuration}>
                            {renderNode(sectionDiv0Div0Div1Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div1Div0ImageWithBasePath0ImageRenderer, (
                                <SmartImage src={sectionDiv0Div0Div1Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div1Div0ImageWithBasePath0ImageAlt} className="img-fluid" {...(sectionDiv0Div0Div1Div0ImageWithBasePath0ImageProps ?? {})} />
                            ))}
                            <div className="banner-user-call">
                                <span className="avatar">
                                    {renderNode(sectionDiv0Div0Div1Div0Div0Span0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div1Div0Div0Span0ImageWithBasePath0ImageRenderer, (
                                        <SmartImage src={sectionDiv0Div0Div1Div0Div0Span0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div1Div0Div0Span0ImageWithBasePath0ImageAlt} className="img-fluid rounded-circle" {...(sectionDiv0Div0Div1Div0Div0Span0ImageWithBasePath0ImageProps ?? {})} />
                                    ))}
                                </span>
                                <p>{sectionDiv0Div0Div1Div0Div0P0PText}</p>
                            </div>
                            <div className="call-items">
                                {renderNode(sectionDiv0Div0Div1Div0Div1Link0LinkVisible, sectionDiv0Div0Div1Div0Div1Link0LinkRenderer, (
                                    <SmartLink href={sectionDiv0Div0Div1Div0Div1Link0LinkHref} className="item-1 item" {...(sectionDiv0Div0Div1Div0Div1Link0LinkProps ?? {})}>
                                        <i className="isax isax-video" />
                                    </SmartLink>
                                ))}
                                {renderNode(sectionDiv0Div0Div1Div0Div1Link1LinkVisible, sectionDiv0Div0Div1Div0Div1Link1LinkRenderer, (
                                    <SmartLink href={sectionDiv0Div0Div1Div0Div1Link1LinkHref} className="item-2 item" {...(sectionDiv0Div0Div1Div0Div1Link1LinkProps ?? {})}>
                                        <i className="isax isax-call-slash" />
                                    </SmartLink>
                                ))}
                                {renderNode(sectionDiv0Div0Div1Div0Div1Link2LinkVisible, sectionDiv0Div0Div1Div0Div1Link2LinkRenderer, (
                                    <SmartLink href={sectionDiv0Div0Div1Div0Div1Link2LinkHref} className="item-3 item" {...(sectionDiv0Div0Div1Div0Div1Link2LinkProps ?? {})}>
                                        <i className="isax isax-microphone-2" />
                                    </SmartLink>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid banner-bg-01" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath1ImageVisible, sectionImageWithBasePath1ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath1ImageSrc} alt={sectionImageWithBasePath1ImageAlt} className="img-fluid banner-bg-02" {...(sectionImageWithBasePath1ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath2ImageVisible, sectionImageWithBasePath2ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath2ImageSrc} alt={sectionImageWithBasePath2ImageAlt} className="img-fluid banner-bg-03" {...(sectionImageWithBasePath2ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath3ImageVisible, sectionImageWithBasePath3ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath3ImageSrc} alt={sectionImageWithBasePath3ImageAlt} className="img-fluid banner-bg-04" {...(sectionImageWithBasePath3ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath4ImageVisible, sectionImageWithBasePath4ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath4ImageSrc} alt={sectionImageWithBasePath4ImageAlt} className="img-fluid banner-bg-05" {...(sectionImageWithBasePath4ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath5ImageVisible, sectionImageWithBasePath5ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath5ImageSrc} alt={sectionImageWithBasePath5ImageAlt} className="img-fluid banner-bg-06" {...(sectionImageWithBasePath5ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath6ImageVisible, sectionImageWithBasePath6ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath6ImageSrc} alt={sectionImageWithBasePath6ImageAlt} className="img-fluid banner-bg-07" {...(sectionImageWithBasePath6ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeTwoBannerSectionGenerated;
